export default Object.freeze({
  // ---------------------------- Backend IP ----------------------------
  REQUEST_IP_ADDRESS: `${window.location.origin}/scope-pa/api/`,

  // ---------------------------- Language ----------------------------
  LOCAL_STORAGE_KEY: "pa-language",
  ES_LANG_KEY: "es",
  EN_LANG_KEY: "en",
  PT_LANG_KEY: "pt",
  DE_LANG_KEY: "de",

  // ---------------------------- Active Channel ----------------------------
  ACTIVE_CHANNEL: "ACH",

  //  ---------------------------- Device Status ----------------------------
  GOOD: "ok",
  ATTENTION: "attention",
  BAD: "bad",
  FAULT: "fault",

  //  ---------------------------- Dados ----------------------------------

  GOOD_DADOS: "Bom - Ok",

  // ---------------------------- Page Scaling Modifiers ----------------------------
  PAGE_HEGHT_MODIFIER: 0.7,
  SCALING_FACTOR_DADOS: 0.55,
  SCALING_FACTOR_TRAFFIC: 0.56,
  SCALING_FACTOR_LOG: 0.54,
  SCALING_FACTOR_LIVE_MATRIX: 0.8,

  // ---------------------------- PA Baud Rate ----------------------------
  PA_BAUD_RATE: "31,25",

  // ---------------------------- Oscilloscope ----------------------------
  OSCILLOSCOPE_CHART_ID: "osc-page-chart-id",
  BA_CHECKBOX_VAL: "ba-check",
  AB_CHECKBOX_VAL: "ab-check",
  PLAY_REFRESH_INTERVAL_MS: 500,
  AUTO_VISUALIZATION_REFRESH_MS: 1500,
  AUTOMATIC_CHECKBOX_VAL: "auto-check",
  MANUAL_CHECKBOX_VAL: "manual-check",
  FETCH_TIMEOUT: 200,
  LOADING_IMG: "loading-img",
  DETAILED_MODE_CHECKBOX_VAL: "detailed-check",
  COMPLETE_MODE_CHECKBOX_VAL: "complete-check",

  // ---------------------------- Bar Graph ----------------------------
  AMPLITUDE_ASC: 1,
  AMPLITUDE_DESC: 2,
  MIN_AMPLITUDE_ASC: 3,
  MIN_AMPLITUDE_DESC: 4,

  BAR_GRAPH_CHART_ID: "bar-gr-chart-id",

  AMPLITUDE_ID: "amp-id",
  MIN_AMPLITUDE_ID: "min-amp-id",
  MAX_AMPLITUDE_ID: "max-amp-id",

  NOISE_ID: "noise-id",
  MIN_NOISE_ID: "min-noise-id",
  MAX_NOISE_ID: "max-noise-id",

  JITTER_ID: "jitter-id",
  MIN_JITTER_ID: "min-jitter-id",
  MAX_JITTER_ID: "max-jitter-id",

  UNBALANCE_ID: "unbalance-id",

  ACTUAL_ID: "actual-id",
  MIN_ID: "min-id",
  MAX_ID: "max-id",

  CHECKBOX_ADDR_VAL: "check-addr",
  CHECKBOX_ASC_VAL: "check-asc",
  CHECKBOX_DESC_VAL: "check-desc",

  MAX_DEV_PER_PAGE: 15,

  AMPLITUDE_MAX_Y_AXIS: 10,
  NOISE_MAX_Y_AXIS: 300,
  UNBALANCE_MAX_Y_AXIS: 100,
  DEVIATION_MAX_Y_AXIS: 2,
  JITTER_MAX_Y_AXIS: 5,


  // ------------------- Hexadecimal value of Colors -------------------
  RED_HEX: "#f44336",
  GREEN_HEX: "#00c853",
  PURPLE_HEX: "#ab47bc",
  BLUE_HEX: "#2185d0",
  ORANGE_HEX: "#F57C00",
  YELLOW_HEX: "#FBC02D",
  BAD_ORANGE_HEX: "#FF5722",
  TEAL_HEX: "#38C7BD",

  FADED_GREEN_HEX: "rgba(0, 200, 83, 0.5)",
  FADED_YELLOW_HEX: "rgba(253, 216, 53, 0.5)",
  FADED_RED_HEX: "rgba(244, 67, 54, 0.5)",

  // ---------------------------- Report ----------------------------
  CONFORM: "C",
  CONFORM_W_RESTRICTION: "CWR",
  NON_CONFORM: "NC",
  HARDWARE_VERSION: "1.0.0",
  SOFTWARE_VERSION: "1.5.0",
  LABELS_FONT_SIZE: "14px",
  LIVE_LIST_ELEMENTS_PER_PAGE: 25,
  RANDOMIZER_CONSTANT: 234567,
  MAX_NUM_OF_LOG_EVENTS: 200,

  // ---------------------- INITIALIZATION ----------------------------
  START_TIME: "START_TIME",

  // ------------------------------- AUTH STR ----------------------------
  AUTH_STR: "f4610aa514477222afac2b77f971d069780ca2846f375849f3dfa3c0047ebbd1",

  FILE_UPDATE_TYPE: "file-update",
  INTERFACE_CONFIG_UPDATE_TYPE: "interface-config-update",

  NOT_UPDATING: "notUpdating",
  UPDATE_FILES_FOUND: "updateFilesFound",
  FINISHED_UPDATING: "finishedUpdating",
  RESTARTING_MONITOR: "restartingMonitor",

  // ---------------------------- WLAN Config ----------------------------
  CONNECTED_STATUS: "connected",
  DISCONNECTED_STATUS: "disconnected",

  DHCP_MODE: "dhcp",
  FIXED_IP_MODE: "fixedIp",

  // -------------------------------  TS EXPERT ----------------------------
  PA_TERMINATION_OFF_PROBLEM_TYPE: "terminationOFF",
  PA_CAPACITIVE_EFFECT_PROBLEM_TYPE: "capacitiveEffect",
  PA_HIGH_RESISTANCE_PROBLEM_TYPE: "highResistance",
  PA_INVERTED_POLARITY_PROBLEM_TYPE: "invertedPolarity",
  PA_NOISE_PROBLEM_TYPE: "noise",
  PA_DADOS_PROBLEM_TYPE: "dados",
  PA_UNBALANCE_PROBLEM_TYPE: "unbalance",

  // ------------------------------- EDIT TAGS ----------------------------
  TS_MONITOR_PROFIBUS_PRODUCT_TYPE: "mn-pb",

  // ------------------------------- NTP UPDATE STATUS ----------------------------
  NTP_UPDATE_TYPE: "turnNtpOn",
  
  NTP_UPDATE_NOT_STARTED: "notUpdating",
  NTP_UPDATE_START: "start",
  NTP_UPDATE_SUCCESS: "sucess",
  NTP_UPDATE_FAIL: "fail",
});
